module.exports = __webpack_public_path__ + "static/media/cape-1.f4d87943.glb";